// ISO8601 文字列の先頭日付部分（YYYY-MM-DD、後続は T か文字列末尾）を取り出す正規表現。
const ISO_DATE_PREFIX_PATTERN = /^(\d{4})-(\d{2})-(\d{2})(?:T|$)/;

const JST_FORMATTER = new Intl.DateTimeFormat("ja-JP", {
  timeZone: "Asia/Tokyo",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  hour12: false,
});

export function formatJstDateTime(value: string | number | Date): string {
  // new Date("2026-02-31T...") は 3/3 へ繰り上がるため、finite 判定だけでは非実在日を弾けない。
  // 壊れた API 応答や保存値が「別日の正しそうな日時」として表示されるのを防ぐため、
  // ISO 日付プレフィックスを持つ文字列は、整形前に日付部分が実在することを検証する。
  if (typeof value === "string" && !hasExistingIsoDatePart(value)) return "日時不明";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "日時不明";
  return JST_FORMATTER.format(date);
}

// 文字列が ISO 日付プレフィックスを持つ場合に、その年月日が実在するか（rollover していないか）を判定する。
// ISO 日付プレフィックスでない文字列は判定対象外（true）として、従来どおり new Date の解釈に委ねる。
function hasExistingIsoDatePart(value: string): boolean {
  const match = ISO_DATE_PREFIX_PATTERN.exec(value);
  if (!match) return true;

  const [, yearText, monthText, dayText] = match;
  if (!yearText || !monthText || !dayText) return false;

  const year = Number.parseInt(yearText, 10);
  const month = Number.parseInt(monthText, 10);
  const day = Number.parseInt(dayText, 10);
  // UTC の同一年月日を組み立て、繰り上がりが起きていなければ実在日とみなす。
  const normalized = new Date(Date.UTC(year, month - 1, day));

  return (
    normalized.getUTCFullYear() === year &&
    normalized.getUTCMonth() === month - 1 &&
    normalized.getUTCDate() === day
  );
}
